// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".step-icon[data-v-a3c4d886]{display:flex;align-items:center;justify-content:center;height:25px;width:90px}", ""]);
// Exports
module.exports = exports;
